import React, { useState, useEffect } from 'react';
import { Row, Col, Form, Radio, Button } from 'antd';
import Firebase from '../../utils/firebaseConfig';
import '../../assets/css/registro.css';

const nombre_evento = 'ies-2023';
const app = new Firebase();

const PopUpPregunta = (props) => {

    const { num_pregunta, onResponse, idioma, dia } = props;
    const [pregunta, setPregunta] = useState('');
    const [respuestas, setRespuestas] = useState([]);
    const [pregunta_ingles, setPreguntaIngles] = useState('');
    const [respuestas_ingles, setRespuestasIngles] = useState([]);

    useEffect(() => {
        app.obtener_objetos(nombre_evento+'/preguntas-popup',false,(items) => {

            let preg = items.filter(item => {
                if(item.num_pregunta === num_pregunta && item.dia === dia){
                    return true;
                }else{
                    return false;
                }
            });

            if(preg.length === 1){
                setPregunta(preg[0].pregunta);
                setRespuestas(Object.values(preg[0].respuestas));
                setPreguntaIngles(preg[0].pregunta_ingles);
            }
        });
    },[]);

   


    const onFinish = values => {
        onResponse(values["radio-group"]);
      };

    return(
        <Row>
            <Col span={20} offset={2}>
            <p className="color_azul"><strong>{idioma === 'es' ? pregunta: pregunta_ingles}</strong></p>
            <Form
            name="validate_other"
            onFinish={onFinish}
            initialValues={{
            }}
          >

            <Form.Item name="radio-group" label="" 
            rules={[
          {
            required: true,
            message: <span style={{color:'red'}}>{idioma === 'es' ? 'Elige una opción' : 'Choose an option'}</span>,
          }
        ]}>
        <Radio.Group style={{textAlign:'left'}}>
            {respuestas.map(respuesta => {
                return(
                    <>
                        <Radio value={respuesta.respuesta}><span className="selector_radio_opcion">{idioma === 'es' ? respuesta.respuesta : respuesta.respuesta_ingles}</span></Radio>
                        <br />
                    </>
                );
            })}
        </Radio.Group>
      </Form.Item>

      <Form.Item
        style={{textAlign:'center'}}
      >
        <Button className="boton_sin_login" htmlType="submit">
          {idioma === 'es' ? 'Votar' : 'Vote'}
        </Button>
      </Form.Item>
    </Form>

            </Col>
        </Row>
    );
}

export default PopUpPregunta;
